module.exports = __webpack_public_path__ + "img/test03-2.6383f077.jpg";